module.exports = "<template>\n    <b-timepicker v-model=\"time\" inline></b-timepicker>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                time: new Date()\n            }\n        }\n    }\n</script>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./docs/pages/components/timepicker/examples/ExInline.vue
// module id = 1563
// module chunks = 15